import {Component, OnInit} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import {LanguageService} from './service/language.service';
import { Meta, Title } from '@angular/platform-browser';
import {filter} from 'rxjs/operators';
import {UserNameCommunication} from './service/userNameCommunication.service';


@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    animations: [
    // animation triggers go here
    ],
    standalone: false
})
export class AppComponent implements OnInit {

  // tslint:disable-next-line:variable-name
  constructor(private meta: Meta, private meta_title: Title, private translate: TranslateService,
              // tslint:disable-next-line:variable-name
              private _language: LanguageService, private router: Router, private userNameCommunication: UserNameCommunication) {
    this._language.current_lang.subscribe((lang: number) => {
      if (lang === 0 ) {
        translate.use('ro');
        this.language = 0;
      } else {
        translate.use('en');
        this.language = 1;
      }
    });
    userNameCommunication.userName.subscribe(username => {
      this.userName = username;
    });
  }
  active = false;
  year = 0;
  isCookieVisible = true;
  isCookiesAccepted = false;
  userName = '';
  language = 0;
  isLoaderVisible = false;

  onBurgerClicked(): void {
    this.active = !this.active;
  }

  getYear(): void {
    this.year = new Date().getFullYear();
  }
  acceptCookies(): void {
    localStorage.setItem('cookiesConsentResponse', 'yes');
    this.loadGoogleAnalytics();
    this.isCookieVisible = false;
  }
  refuseCookies(): void {
    localStorage.setItem('cookiesConsentResponse', 'no');
    this.isCookieVisible = false;
  }
  redirect(): void {
    this.router.navigate(['/TermsConditions']);
  }
  checkCookie(): void {
    const cookieResponseExists = localStorage.getItem('cookiesConsentResponse');
    if (cookieResponseExists) {
      if (cookieResponseExists === 'yes'){
        this.isCookiesAccepted = true;
        this.loadGoogleAnalytics();
      }
      if (cookieResponseExists === 'no'){
        this.isCookiesAccepted = false;
      }
      this.isCookieVisible = false;
    }
  }
  loadGoogleAnalytics(): void {
    // Load GA script
    console.log('gtag works');
    const script1 = document.createElement('script');
    script1.src = 'https://www.googletagmanager.com/gtag/js?id=G-3NG2KFDSLD';
    script1.async = true;
    document.head.appendChild(script1);

    // Init script
    const script2 = document.createElement('script');
    script2.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'G-3NG2KFDSLD');
    `;
    document.head.appendChild(script2);
  }
  changeLanguage(lang: string | any): void {
    this.isLoaderVisible = true;
    setTimeout(() => {
      console.log('change lang', lang.value);
      console.log('change lang', typeof lang.value);
      this._language.update_lang(Number(lang.value));
      this.isLoaderVisible = false;
    }, 1000);

  }
  ngOnInit(): void {
    localStorage.removeItem('acceptedCookie'); // remove old cookies response
    this.checkCookie();
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event) => {
        this.active = false;
      });
    this.active = false;
    this.getYear();
    this.meta_title.setTitle('Lupul Creativ - Galerie de artă, tablouri personalizate la comandă, mărțișoare și decorațiuni de crăciun lucrate manua');
    this.meta.addTags([
      { name: 'description', content: 'Descoperă lucrările de artă unice și picturile personalizate create de Lupul Creativ. Explorează o galerie de piese originale de artă.' },
      // tslint:disable-next-line:max-line-length
      { name: 'keywords', content: 'artă, picturi, picturi personalizate, lucrări de artă, artă contemporană, ornamente Crăciun, mărțișoare, handmade, tablou personalizat, tablou la comandă' },
      { name: 'author', content: 'Lupul Creativ' },
      { name: 'robots', content: 'index, follow' },
      { property: 'og:title', content: 'Lupul Creativ' },
      { property: 'og:description', content: 'Descoperă lucrări de artă unice și picturi personalizate realizate de Lupul Creativ.' },
      { property: 'og:url', content: 'https://lupulcreativ.ro/' },
      { property: 'og:type', content: 'website' }
    ]);
  }
}
